import * as Connector from 'shared/connectors/offerConnector';
import { OFFER } from 'store/types';

const init = () => ({
  type: OFFER.GET_STATUS_PLOT_INIT,
});

export const success = data => ({
  type: OFFER.GET_STATUS_PLOT_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: OFFER.GET_STATUS_PLOT_FAILURE,
});

const getStatusPlot = plotUuid => async dispatch => {
  dispatch(init());
  try {
    const data = await Connector.getStatusPlot(plotUuid);
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getStatusPlot;
